module.exports = __webpack_public_path__ + "img/1925_no.4c88cdbc.svg";